import React from 'react';
import PropTypes from 'prop-types';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

const ServiceType = ({ service, industryId, onDelete, onEdit, className = '' }) => {
  return (
    <div
      className={`relative border border-gray-200 font-nohemi font-light rounded-2xl transition duration-300 bg-white ${className}`}>
      <div className="w-full h-40 overflow-hidden bg-gray-100 rounded-t-2xl">
        <img src={service.imageUrl} alt={service.name} className="object-cover w-full h-full" />
      </div>
      <div className="p-4 space-y-2">
        <p className="text-xl font-semibold truncate">{service.name}</p>
        <p className="text-sm text-gray-500 line-clamp-2">{service.description}</p>

        <div className="flex items-center justify-between">
          <div className="flex gap-2">
            <button
              onClick={() => onEdit('update', { _id: industryId }, service)}
              className="p-2 text-gray-500 transition border border-gray-300 rounded-full hover:text-gray-700 hover:border-gray-700">
              <FiEdit size={10} />
            </button>
          </div>

          <button
            onClick={() => onDelete(service._id)}
            className="p-2 text-red-500 transition border border-red-300 rounded-full hover:text-red-700 hover:border-red-700">
            <FiTrash2 size={10} />
          </button>
        </div>
      </div>
    </div>
  );
};
ServiceType.propTypes = {
  service: PropTypes.shape({
    imageUrl: PropTypes.string,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    _id: PropTypes.string.isRequired,
  }).isRequired,
  industryId: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default ServiceType;
